import { all, fork } from 'redux-saga/effects';
// import { watchIsIntro, watchIsLogin, watchLogin, watchLogout, watchQuestion, watchRegistration, watchresetEmail, watchupdateProfile, watchUserInfo, watchWallet } from './Saga/UserSaga';
import { watchCommonContent, watchHome } from './saga/HomeSaga';
import { watchCheckAuth, watchLogout, watchLogin, watchSignup, watchUpdateCustomer,watchDeleteAddress,watchUpdateAddress,watchAddAddress, watchResetPassword, watchForgotPassword } from './saga/AuthSaga';
import { languageSaga } from './saga/LanguageSaga';
export function* rootSaga() {
    // yield all([fork(watchLogin)])
    // yield all([fork(watchIsLogin)])
    // yield all([fork(watchRegistration)])
    yield all([fork(watchHome)])
    yield all([fork(watchCommonContent),fork(languageSaga),])
    yield all([fork(watchSignup)])
    yield all([fork(watchLogin)])
    yield all([fork(watchCheckAuth)])
    yield all([fork(watchLogout)])
    yield all([fork(watchUpdateCustomer)])
    yield all([fork(watchAddAddress)])
    yield all([fork(watchUpdateAddress)])
    yield all([fork(watchDeleteAddress)])
    // yield all([fork(watchDetail)])
    // yield all([fork(watchAddRemoveWishlist)])
    // yield all([fork(watchListWishlist)])
    // yield all([fork(watchDeleteWishlist)])
    // yield all([fork(watchStoreList)])
    // yield all([fork(watchStoreListProduct)])
    // yield all([fork(watchCartList)])
    // yield all([fork(watchdeleteCartList)])
    // yield all([fork(watchUpdateMultipleCartList)])
    yield all([fork(watchResetPassword)])
    yield all([fork(watchForgotPassword)])
    // yield all([fork(watchCategory)])
    // yield all([fork(watchShopByCategory)])
    // yield all([fork(watchShopByBrand)])
    // yield all([fork(watchBrand)])
    // yield all([fork(watchFollowedStoreList)])
    // yield all([fork(watchOrderList)])
    // yield all([fork(watchOrderDetail)])
    // yield all([fork(watchSearchProduct)])
    // yield all([fork(watchOffer)])
    // yield all([fork(watchCurrency)])
    // yield all([fork(watchCurrencySelect)])
    // yield all([fork(watchFollowPress)])
    // yield all([fork(watchUserInfo)])
    // yield all([fork(watchupdateProfile)])
    // yield all([fork(watchLogout)])
    // yield all([fork(watchQuestionProduct)])
    // yield all([fork(watchLegal)])
    // yield all([fork(watchQuestion)])
    // yield all([fork(watchFAQS)])
    // yield all([fork(watchWallet)])
    // yield all([fork(watchApplyCopon)])
    // yield all([fork(watchApplyCredit)])
    // yield all([fork(watchMyReview)])
    // yield all([fork(watchGiveReview)])
    // yield all([fork(watchSubmitReview)])
    // yield all([fork(watchresetEmail)])
    // yield all([fork(watchAbout)])
    // yield all([fork(watchHelpCenter)])
    // yield all([fork(watchIsIntro)])
    // yield all([fork(watchSellOnAzaro)])
    // yield all([fork(watchHowToSell)])
    // yield all([fork(watchinquiry)])
}
